module.exports = __webpack_public_path__ + "static/media/walkUp.32ac9a18.png";